import { Alert, Flex } from 'antd';
import { Subtitle, Text } from 'components/mvp-typography';

interface EmptyBalanceAlertProps {
  assessmentType: string;
}

export function EmptyBalanceAlert(props: EmptyBalanceAlertProps) {
  return (
    <Flex align="center" vertical>
      <Alert
        type="warning"
        showIcon
        message={<Subtitle>Zero balance</Subtitle>}
        description={
          <Flex vertical gap={16}>
            <Text>
              Your balance for the <b>{props.assessmentType}</b> assessment is
              0. Your organisation has disabled pay-per-use purchases of
              assessments for this type.
            </Text>
            <Text>
              Please contact the billing administrator to top up the
              organisation billing.
            </Text>
          </Flex>
        }
        style={{
          maxWidth: 500
        }}
      />
    </Flex>
  );
}
